import React, { FC } from 'react';
import classNames from 'classnames';
import ValidationMessage from '../ValidationMessage';
import { FieldProps } from '../models';
import './InputField.scss';

const InputField: FC<FieldProps> = (props) => {
  const {
    isRequired = false,
    id,
    type,
    label,
    errorMessage,
    ariaLabel,
    placeholder,
    ts,
    value,
    ...other
  } = props;
  const errorMessageId = `${id}Error`;

  return (
    <div>
      <div
        className={classNames(`form-field form-field__${type}`, {
          'form-field__error': errorMessage,
          'form-field__required': isRequired,
        })}
      >
        <label className="form-field__label" htmlFor={id}>
          {ts[label]}
        </label>
        <input
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessageId}
          aria-label={ts[ariaLabel]}
          type={type}
          id={id}
          value={value}
          {...(placeholder && { placeholder: ts[placeholder] })}
          {...other}
        />
      </div>
      {errorMessage && (
        <ValidationMessage errorId={errorMessageId} errorMessage={ts[errorMessage]} />
      )}
    </div>
  );
};

export default InputField;
